// // src/hooks/klines/adapters/ourbitSpot.js

// const DEFAULT_PROXY =
//   `${process.env.REACT_APP_BACKEND_URL}/proxy`;

// const INTERVAL_MAP = {
//   "1m":  { key: "Min1",  ms: 60_000 },
//   "3m":  { key: "Min3",  ms: 3 * 60_000 },
//   "5m":  { key: "Min5",  ms: 5 * 60_000 },
//   "15m": { key: "Min15", ms: 15 * 60_000 },
//   "30m": { key: "Min30", ms: 30 * 60_000 },
//   "1h":  { key: "Hour1", ms: 60 * 60_000 },
//   "2h":  { key: "Hour2", ms: 2 * 60 * 60_000 },
//   "4h":  { key: "Hour4", ms: 4 * 60 * 60_000 },
//   "6h":  { key: "Hour6", ms: 6 * 60 * 60_000 },
//   "8h":  { key: "Hour8", ms: 8 * 60 * 60_000 },
//   "12h": { key: "Hour12", ms: 12 * 60 * 60_000 },
//   "1d":  { key: "Day1",  ms: 24 * 60 * 60_000 },
//   "1w":  { key: "Week1", ms: 7 * 24 * 60 * 60_000 },
//   "1M":  { key: "Month1",ms: 30 * 24 * 60 * 60_000 },
// };

// // "ETHUSDT" | "ETH_USDT" | "eth-usdt" -> "ETH_USDT"
// function toOurbitSymbol(input) {
//   const s = String(input || "").toUpperCase().replace(/[-]/g, "_");
//   if (!s) return null;
//   if (/_USDT$/.test(s)) return s;
//   const m = s.match(/^([A-Z0-9]+)USDT$/);
//   if (m) return `${m[1]}_USDT`;
//   return `${s}_USDT`;
// }

// function toKeyMs(tf) {
//   const o = INTERVAL_MAP[tf] || INTERVAL_MAP["1m"];
//   return { intervalKey: o.key, intervalMs: o.ms };
// }

// function spotUrl({ sym, startMs, endMs, intervalKey, openPriceMode = "LAST_CLOSE" }) {
//   const base = "https://www.ourbit.com/api/platform/spot/market/kline";
//   const p = new URLSearchParams({
//     symbol: sym,
//     interval: intervalKey,
//     start: String(startMs),
//     end: String(endMs),
//     openPriceMode, // как в их UI-запросе
//   });
//   return `${base}?${p.toString()}`;
// }

// // === нормализация под {time, open, high, low, close, volume} ===
// // ответ: { code:200, data:{ o[], h[], l[], c[], q[], v[], t[], s:count }, ... }
// function normalizeKlines(json) {
//   const ok = json?.code === 200 && json?.msg === "success";
//   const d  = json?.data || {};
//   const T  = Array.isArray(d.t) ? d.t : [];
//   if (!ok || T.length === 0) return [];

//   const O = d.o ?? [];
//   const H = d.h ?? [];
//   const L = d.l ?? [];
//   const C = d.c ?? [];
//   // «q» — обычно базовый объём (quantity), «v» — quote volume (в деньгах).
//   // Для volume берём q, если есть, иначе v.
//   const Q = d.q ?? d.v ?? [];

//   const n = T.length;
//   const out = [];
//   for (let i = 0; i < n; i++) {
//     const time   = Number(T[i]) * 1000; // сервер даёт секунды → мс
//     const open   = Number(O[i]);
//     const high   = Number(H[i]);
//     const low    = Number(L[i]);
//     const close  = Number(C[i]);
//     const volume = Number(Q[i]);
//     if ([time, open, high, low, close].every(Number.isFinite)) {
//       out.push({ time, open, high, low, close, volume });
//     }
//   }
//   return out;
// }

// /**
//  * История клайнов Ourbit SPOT, нормализованная в [{time,open,high,low,close,volume}]
//  *
//  * Если не передали start/end — считаем «хвост» по limit и interval.
//  */
// export async function ourbitSpotFetchHistory({
//   symbol,
//   interval = "1m",
//   limit = 300,
//   // можно пробросить свои окна:
//   startMs,
//   endMs,
//   proxy = DEFAULT_PROXY,
//   openPriceMode = "LAST_CLOSE",
// } = {}) {
//   const sym = toOurbitSymbol(symbol);
//   if (!sym) throw new Error("ourbitSpot: bad symbol");

//   const { intervalKey, intervalMs } = toKeyMs(interval);
//   const end = Number.isFinite(endMs) ? endMs : Date.now();
//   // Берём с запасом на всякий случай +5 баров
//   const start = Number.isFinite(startMs)
//     ? startMs
//     : end - (limit + 5) * intervalMs;

//   const url = spotUrl({ sym, startMs: start, endMs: end, intervalKey, openPriceMode });
//   const finalUrl = proxy ? `${proxy}/${url}` : url;

//   // дебаг
//   console.log("[OURBIT SPOT KLINES] URL:", finalUrl);

//   // const r = await fetch(finalUrl);
//   const r = await fetch(finalUrl, {
//     headers: {
//       'ngrok-skip-browser-warning': 'true',
//     },
//   });
//   if (!r.ok) throw new Error(`ourbitSpot: HTTP ${r.status}`);
//   const js = await r.json();

//   const arr = normalizeKlines(js);
//   console.log("[OURBIT SPOT KLINES] candles:", arr.length);

//   // Возвращаем только последние limit
//   return Array.isArray(arr) && limit > 0 ? arr.slice(-limit) : arr;
// }

// export const ourbitSpotUtils = {
//   toOurbitSymbol,
//   toKeyMs,
//   INTERVAL_MAP,
// };
/* eslint-disable no-console */
const DEFAULT_PROXY = `${process.env.REACT_APP_BACKEND_URL || ""}/proxy`;

const INTERVAL_MAP = {
  "1m":  { key: "Min1",  ms: 60_000 },
  "3m":  { key: "Min3",  ms: 3 * 60_000 },
  "5m":  { key: "Min5",  ms: 5 * 60_000 },
  "15m": { key: "Min15", ms: 15 * 60_000 },
  "30m": { key: "Min30", ms: 30 * 60_000 },
  "1h":  { key: "Hour1", ms: 60 * 60_000 },
  "2h":  { key: "Hour2", ms: 2 * 60 * 60_000 },
  "4h":  { key: "Hour4", ms: 4 * 60 * 60_000 },
  "6h":  { key: "Hour6", ms: 6 * 60 * 60_000 },
  "8h":  { key: "Hour8", ms: 8 * 60 * 60_000 },
  "12h": { key: "Hour12", ms: 12 * 60 * 60_000 },
  "1d":  { key: "Day1",  ms: 24 * 60 * 60_000 },
  "1w":  { key: "Week1", ms: 7 * 24 * 60 * 60_000 },
  "1M":  { key: "Month1",ms: 30 * 24 * 60 * 60_000 },
};

function toOurbitSymbol(input) {
  const s = String(input || "").trim().toUpperCase().replace(/[-]/g, "_");
  if (!s) return null;
  if (/_USDT$/.test(s)) return s;
  const m = s.match(/^([A-Z0-9]+)USDT$/);
  if (m) return `${m[1]}_USDT`;
  return `${s}_USDT`;
}

function toKeyMs(tf) {
  const o = INTERVAL_MAP[tf] || INTERVAL_MAP["1m"];
  return { intervalKey: o.key, intervalMs: o.ms };
}

function spotUrl({ sym, startMs, endMs, intervalKey, openPriceMode = "LAST_CLOSE" }) {
  const base = "https://www.ourbit.com/api/platform/spot/market/kline";
  const p = new URLSearchParams({
    symbol: sym,
    interval: intervalKey,
    start: String(startMs),
    end: String(endMs),
    openPriceMode,
  });
  return `${base}?${p.toString()}`;
}

function toNum(v) {
  const n = typeof v === "string" ? Number(v) : +v;
  return Number.isFinite(n) ? n : NaN;
}

// === нормализация под [{time, open, high, low, close, volume}] ===
function normalizeKlines(json) {
  const ok = json?.code === 200 || json?.success === true;
  const d  = json?.data || json?.result || {};
  const T  = Array.isArray(d.t) ? d.t : Array.isArray(d.time) ? d.time : [];

  if (!ok || T.length === 0) return [];

  const O = d.o ?? d.open  ?? [];
  const H = d.h ?? d.high  ?? [];
  const L = d.l ?? d.low   ?? [];
  const C = d.c ?? d.close ?? [];
  const Q = d.q ?? d.v ?? d.volume ?? d.amount ?? [];

  const out = [];
  const n = T.length;
  for (let i = 0; i < n; i++) {
    let t = toNum(T[i]);
    if (!Number.isFinite(t)) continue;
    if (t < 2e10) t *= 1000; // sec→ms

    const o = toNum(O[i]);
    const h = toNum(H[i]);
    const l = toNum(L[i]);
    const c = toNum(C[i]);
    const v = toNum(Q[i]);

    if ([t, o, h, l, c].every(Number.isFinite)) {
      out.push({ time: t, open: o, high: h, low: l, close: c, volume: Number.isFinite(v) ? v : 0 });
    }
  }

  out.sort((a, b) => a.time - b.time);
  const dedup = [];
  let lastT = -1;
  for (const k of out) {
    if (k.time !== lastT) { dedup.push(k); lastT = k.time; }
    else dedup[dedup.length - 1] = k;
  }
  return dedup;
}

/**
 * История клайнов Ourbit SPOT
 */
export async function ourbitSpotFetchHistory({
  symbol,
  interval = "1m",
  limit = 300,
  startMs,
  endMs,
  proxy = DEFAULT_PROXY,
  openPriceMode = "LAST_CLOSE",
} = {}) {
  const sym = toOurbitSymbol(symbol);
  if (!sym) throw new Error("ourbitSpot: bad symbol");

  const { intervalKey, intervalMs } = toKeyMs(interval);
  const end = Number.isFinite(endMs) ? endMs : Date.now();
  const start = Number.isFinite(startMs) ? startMs : end - (limit + 5) * intervalMs;

  const url = spotUrl({ sym, startMs: start, endMs: end, intervalKey, openPriceMode });
  const finalUrl = proxy ? `${proxy}/${url}` : url;

  console.log("[OURBIT SPOT KLINES] URL:", finalUrl);

  const r = await fetch(finalUrl, { headers: { "ngrok-skip-browser-warning": "1" } });
  if (!r.ok) throw new Error(`ourbitSpot: HTTP ${r.status}`);
  const js = await r.json().catch(() => ({}));

  const arr = normalizeKlines(js);
  console.log("[OURBIT SPOT KLINES] candles:", arr.length);

  return Array.isArray(arr) && limit > 0 ? arr.slice(-limit) : arr;
}

export const ourbitSpotUtils = { toOurbitSymbol, toKeyMs, INTERVAL_MAP };
